// src/features/fourlink-config/utils/helpers/formatters.js

import { WEEKDAY_OPTIONS } from './constants';

export const formatHorarioRange = ({ startTime, endTime }) => {
  const formatTime = (value) => {
    if (!value) return '--:--';
    const trimmed = String(value).trim();
    if (/^\d{4}$/.test(trimmed)) {
      return `${trimmed.slice(0, 2)}:${trimmed.slice(2)}`;
    }
    return trimmed;
  };

  if (!startTime && !endTime) {
    return 'Horario sin horas definidas';
  }

  if (!startTime) {
    return `Fin: ${formatTime(endTime)}`;
  }

  if (!endTime) {
    return `Inicio: ${formatTime(startTime)}`;
  }

  return `${formatTime(startTime)} - ${formatTime(endTime)}`;
};

export const formatDiasSemanaValues = (values) => {
  if (!Array.isArray(values) || values.length === 0) {
    return '';
  }
  const uniqueSorted = Array.from(new Set(values)).sort((a, b) => {
    const orderA = WEEKDAY_OPTIONS.findIndex(opt => opt.value === a);
    const orderB = WEEKDAY_OPTIONS.findIndex(opt => opt.value === b);
    return orderA - orderB;
  });
  return uniqueSorted
    .map((value) => WEEKDAY_OPTIONS.find((option) => option.value === value)?.label || value)
    .join('; ');
};

export const normalizePlainText = (value) => {
  if (value === undefined || value === null) return '';
  return String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
};